module.exports = __webpack_public_path__ + "static/peptide_grey-1ebdd84e3190577ea1b3ddd1abcc30a8.png";